import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import InboxIcon from "@material-ui/icons/Inbox";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "48px 24px",
      textAlign: "center",
      // no celular a tabela rola de lado: o aviso fica preso à área visível em vez de centrar na largura da tabela
      [theme.breakpoints.down("xs")]: {
        padding: "32px 16px",
        position: "sticky",
        left: 0,
        width: "calc(100vw - 58px)",
        maxWidth: "100%",
        boxSizing: "border-box",
      },
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 48,
      height: 48,
      borderRadius: t.radius.md,
      marginBottom: 12,
      // ícone discreto: superfície suave e tinta secundária, sem a cor da marca
      backgroundColor: t.muted,
      border: `1px solid ${t.line}`,
      color: t.textSecondary,
      "& .MuiSvgIcon-root": {
        fontSize: 24,
        color: "inherit",
      },
    },
    title: {
      fontFamily: t.font,
      fontSize: 14,
      fontWeight: 600,
      lineHeight: 1.4,
      color: t.text,
      margin: 0,
    },
    message: {
      fontFamily: t.font,
      fontSize: 13,
      lineHeight: 1.5,
      color: t.textSecondary,
      maxWidth: 384,
      margin: "4px 0 0",
    },
    action: {
      marginTop: 16,
    },
  };
});

/**
 * Estado vazio (dentro de tabelas, listas, painéis).
 *
 * Props: `icon?`, `title?`, `message?` (alias `description?`), `action?` (nó React).
 */
const EmptyState = ({ icon, title, message, description, action, className }) => {
  const classes = useStyles();
  const text = message || description;
  return (
    <div className={[classes.root, className].filter(Boolean).join(" ")}>
      <div className={classes.iconWrapper}>{icon || <InboxIcon />}</div>
      <Typography component="p" className={classes.title}>
        {title || "Nada por aqui ainda"}
      </Typography>
      {text && (
        <Typography component="p" className={classes.message}>
          {text}
        </Typography>
      )}
      {action && <div className={classes.action}>{action}</div>}
    </div>
  );
};

export default EmptyState;
